import type { CreateFollowUpInput, UpdateFollowUpInput } from '../../schemas/followUps.js';
import type { FollowUpItem, FollowUpsSnapshot } from '../../types/index.js';
import type { RequestFn } from '../http.js';

/** Follow-ups ("Ответить позже") — personal, private reminders to revisit a
 *  message. All routes are `me`-scoped; the server derives the channel from the
 *  message and validates the caller can see it. */
export function makeFollowUpsApi(request: RequestFn) {
  return {
    listFollowUps: () => request<FollowUpsSnapshot>('/api/me/follow-ups'),
    /** Create (or re-arm, server upserts on the unique user+message pair). */
    createFollowUp: (input: CreateFollowUpInput) =>
      request<FollowUpItem>('/api/me/follow-ups', {
        method: 'POST',
        body: JSON.stringify(input),
      }),
    /** Snooze (`remindAt`), complete/reopen (`status`) or edit the note. */
    updateFollowUp: (id: string, input: UpdateFollowUpInput) =>
      request<FollowUpItem>(`/api/me/follow-ups/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(input),
      }),
    deleteFollowUp: (id: string) =>
      request<void>(`/api/me/follow-ups/${id}`, { method: 'DELETE' }),
  };
}
